<div class="p-mr-2 p-mb-2" *ngIf="showEKYCButton">
  <a class="btn btn-tertiary text-center" (click)="showQueryDialog()">{{
      "Common.Button.EKYC" | translate
    }}</a>
</div>

<p-dialog
  *ngIf="isDialogMode else basicDisplayMode"
  [(visible)]="isShowQueryDialog"
  [modal]="true"
  [draggable]="false"
  closeIcon="pi pi-close"
  styleClass="p-dialog-lg"
  appendTo="body"
  [contentStyle]="{ overflow: 'scroll' }"
  (onHide)="CancelDialog()"
>
  <!--todo-->
  <ng-template pTemplate="header">
    <h1>
      {{ "Common.Button.EKYC" | translate }}
    </h1>
  </ng-template>
  <div class="cfc-list cfc-max-height-600">
    <ul class="cfc-list-wrapper">
      <li class="cfc-list-item" *ngFor="let record of eKYCRecords">
        <div class="p-field-label">
          <label>
            <small class="p-text-red p-required">*</small>
            {{ record.title | translate }}
          </label>
        </div>
        <div>
          <label
            pButton
            type="button"
            [label]="'SigvLibrary.Upload' | translate"
            icon="pi pi-cust-upload"
            class="p-button-action p-button-outlined p-content-button p-mt-2"
          >
            <input
              type="file"
              style="display: none"
              accept=".jpg, .jpeg, .png"
              #uploadSignatureInput
              (change)="selectedUploadSignatureFile($event.target, record.name)"
            />
          </label>
          <label
            pButton
            type="button"
            [label]="'Common.Button.TakePhoto' | translate "
            icon="pi pi-camera"
            class="p-button-action p-button-outlined p-content-button p-mt-2"
            [hidden]="!needWebcam"
          >
            <input
              type="button"
              style="display: none"
              accept=".jpg, .jpeg, .png"
              (click)="startCamera(record.name, videoElement, canvas)"
            />
          </label>


          <div [hidden]="!record.showCam">
            <label pButton type="button" [label]="'Common.Button.CapturePhoto' | translate " icon="pi pi-sync"
                   class="p-button-action p-button-outlined p-content-button p-mt-2" [hidden]="!needWebcam">
              <input type="button" style="display: none" accept=".jpg, .jpeg, .png"
                     (click)="capturePhoto(record.name, videoElement, canvas)"/>
            </label>

            <label pButton type="button" [label]="'Common.Button.SwitchCamera' | translate " icon="pi pi-sync"
                   class="p-button-action p-button-outlined p-content-button p-mt-2" [hidden]="!needWebcam">
              <input type="button" style="display: none" accept=".jpg, .jpeg, .png"
                     (click)="switchCamera(record.name, videoElement)"/>
            </label>
            <video #videoElement autoplay [width]="videoWidth" [height]="videoHeight" playsinline></video>
            <canvas #canvas [width]="videoWidth" [height]="videoHeight" style="display:none;"></canvas>
          </div>


        </div>
        <div>
          <img
            title="{{ record.title | translate }}"
            *ngIf="record.img"
            class="p-mt-2 previewImg"
            [src]="record.src"
          />
        </div>
        <span class="p-text-secondary p-mt-4">{{
            "Common.Validate.EKYCUploadMessage" | translate
          }}</span>
      </li>
    </ul>
  </div>
  <button
    title="Validate"
    pButton
    type="button"
    [label]="'Common.Button.EKYC' | translate"
    class="p-mt-2 p-content-button p-mr-2 btn-primary"
    (click)="Validate()"
  ></button>

  <h2 class="successful" *ngIf="validationResults.status === true">
    <i class="pi pi-check"></i> {{ validationResults.date | date : dateFormat }}
    {{ "Common.Validate.EKYCValidateSuccessful" | translate }} <span
    *ngIf="needScore">{{ "Common.Label.EKYCScore" | translate }} {{ ekycScore }}</span>
  </h2>
  <h2 class="failed" *ngIf="validationResults.status === false">
    <i class="pi pi-times"></i> {{ validationResults.date | date : dateFormat }}
    {{ "Common.Validate.EKYCValidateFailed" | translate }}
  </h2>
</p-dialog>

<ng-template #basicDisplayMode>
  <div class="cfc-list cfc-max-height-600">
    <ul class="cfc-list-wrapper">
      <li class="cfc-list-item" *ngFor="let record of eKYCRecords">
        <div class="p-field-label">
          <label>
            <small class="p-text-red p-required">*</small>
            {{ record.title | translate }}
          </label>
        </div>
        <div>
          <label
            pButton
            type="button"
            [label]="'SigvLibrary.Upload' | translate"
            icon="pi pi-cust-upload"
            class="p-button-action p-button-outlined p-content-button p-mt-2"
            *ngIf="record.showUpload"
          >
            <input
              type="file"
              style="display: none"
              accept=".jpg, .jpeg, .png"
              #uploadSignatureInput
              (change)="selectedUploadSignatureFile($event.target, record.name)"
            />
          </label>
          <label
            pButton
            type="button"
            [label]="'Common.Button.TakePhoto' | translate "
            icon="pi pi-camera"
            class="p-button-action p-button-outlined p-content-button p-mt-2"
            [hidden]="!needWebcam"
          >
            <input
              type="button"
              style="display: none"
              accept=".jpg, .jpeg, .png"
              (click)="startCamera(record.name, videoElement, canvas)"
            />
          </label>

          <div [hidden]="!record.showCam">
            <label pButton type="button" [label]="'Common.Button.CapturePhoto' | translate " icon="pi pi-sync"
                   class="p-button-action p-button-outlined p-content-button p-mt-2" [hidden]="!needWebcam">
              <input type="button" style="display: none" accept=".jpg, .jpeg, .png"
                     (click)="capturePhoto(record.name, videoElement, canvas)"/>
            </label>

            <label pButton type="button" [label]="'Common.Button.SwitchCamera' | translate " icon="pi pi-sync"
                   class="p-button-action p-button-outlined p-content-button p-mt-2" [hidden]="!needWebcam">
              <input type="button" style="display: none" accept=".jpg, .jpeg, .png"
                     (click)="switchCamera(record.name, videoElement)"/>
            </label>
            <video #videoElement autoplay [width]="videoWidth" [height]="videoHeight" playsinline></video>
            <canvas #canvas [width]="videoWidth" [height]="videoHeight" style="display:none;"></canvas>
          </div>

        </div>
        <div>
          <img
            title="{{ record.title | translate }}"
            *ngIf="record.img"
            class="p-mt-2 previewImg"
            [src]="record.src"
          />
        </div>
        <span class="p-text-secondary p-mt-4">{{
            "Common.Validate.EKYCUploadMessage" | translate
          }}</span>
      </li>
    </ul>
  </div>
  <button title="Validate" pButton type="button" [label]="'Common.Button.EKYC' | translate"
          class="p-mt-2 p-content-button p-mr-2 btn-primary" (click)="Validate()"></button>

  <h2 class="successful" *ngIf="validationResults.status === true">
    <i class="pi pi-check"></i> {{ validationResults.date | date : dateFormat }}
    {{ "Common.Validate.EKYCValidateSuccessful" | translate }} <span
    *ngIf="needScore && verifyType === 'Web Submission'">{{ "Common.Label.EKYCScore" | translate }} {{ ekycScore | number:'1.2-2' }}</span>
    <span
    *ngIf="needScore && verifyType === 'Commencement'">{{ "Common.Label.EKYCScore" | translate }} {{ formatScore(ekycScore) }}%</span>
  </h2>
  <h2 class="failed" *ngIf="validationResults.status === false">
    <i class="pi pi-times"></i> {{ validationResults.date | date : dateFormat }}
    {{ "Common.Validate.EKYCValidateFailed" | translate }}
  </h2>
</ng-template>
